// MainMenu.js

import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { menuManager } from 'redux/action/menus';
// Import useLocation
import { NavLink, useLocation } from 'react-router-dom';
import { warningAlertSwitchChange } from 'redux/action/warningAlert';
import { TiThSmall } from 'react-icons/ti';
import { FaClipboardList } from 'react-icons/fa';
import { GiSpeaker, GiSpeakerOff } from 'react-icons/gi';

import { MainMenuContainer, MenuIcon } from './MainMenu.css.js';
import MenuButton from './MenuButton.js';

const MainMenu = ({ setMainTitle }) => {
  const dispatch = useDispatch();
  const alertSwitchStatus = useSelector((state) => state.warningAlert.switch);
  const userId = useSelector((store) => store.loginManager.status.currentUser);
  const menus = useSelector((store) => store.menus.menu);
  
  const location = useLocation();

  useEffect(() => {
    dispatch(menuManager(userId));
  }, []);

  useEffect(() => {
    const { pathname } = location;
    if (pathname === '/') {
      setMainTitle('체감온도 모니터링 시스템');
    } else if (pathname === '/icon') {
      setMainTitle('체감온도 모니터링 시스템');
    }
  }, [location, setMainTitle]);


  if (!menus) {
    dispatch(menuManager(userId));
    return null;
  }

  return (
    <MainMenuContainer>
      <MenuIcon
        title="게시판 보기"
        onClick={() => {
        }}
      >
        <NavLink
          exact={'/' === '/'}
          to={'/'}
          activeClassName="activate"
          isActive={(match, location) => {
            if (match || location.pathname === '/') {
              setMainTitle('체감온도 모니터링 시스템');
              return true;
            }
          }}
        >
          <FaClipboardList />
        </NavLink>
      </MenuIcon>
      <MenuIcon
        title="아이콘별 보기"
        onClick={() => {}}
      >
        <NavLink
          exact={'/icon' === '/'}
          to={'/icon'}
          activeClassName="activate"
          isActive={(match, location) => {
            if (match || location.pathname === '/icon') {
              setMainTitle('체감온도 모니터링 시스템');
              return true;
            }
          }}
        >
          <TiThSmall />
        </NavLink>
      </MenuIcon>
      {menus &&
        menus.map((data) => {
          if (data.menu.parentMenuIdx === null) {
            return (
              <MenuButton
                key={data.menu.menuIdx}
                url={data.menu.menuUrl}
                pageName={data.menu.menuNm}
                titleName={data.menu.titleNm}
                subPage={menus.filter((e) => e.menu.parentMenuIdx === data.menu.menuIdx)}
                setMainTitle={setMainTitle}
              />
            );
          }
        })}
    </MainMenuContainer>
  );
};

export default MainMenu;